import {
    Backdrop,
    Box,
    CircularProgress,
    Drawer,
    IconButton,
    Stack,
    Typography,
    useMediaQuery,
  } from "@mui/material";
  import { colors } from "../../theme/theme";
  import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { categoryFilters } from "../../assets/data";
import {
    createExerciseEvent
  } from "../../redux/actions/user.dispatcher";
import {
    Close,
    East,
    EmailOutlined,
    UploadOutlined,
    PersonOutline,
    Today,
    PhoneOutlined,
    ArrowForward
  } from "@mui/icons-material";
import dayGridPlugin from "@fullcalendar/daygrid";
  
  import React, { useEffect, useState } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import { ErrorSnackbar } from "../Common/CustomSnackbar";
  import { getSubscriptionOfUser } from "../../redux/actions/subscriptions.dispatcher";
import FullCalendar from "@fullcalendar/react";
import AddEventDrawer from "../ExerciseCalendar/AddEventDrawer"
import { CustomBtn, SecondaryBtn } from "../Common/CustomBtn";
import axiosInstance from "../../utils/config/config";
  
  const CategoryFiltersDrawer = ({
    drawerState,
    setDrawerState, 
    setSuccess,
    value, 
    setValue 
}) => {
    const [loading, setLoading] = useState(false);
    
    const [errorState, setErrorState] = useState({
      error: false,
      message: "",
    });
    return (
      <Drawer
        anchor={"right"}
        open={drawerState}
        sx={{
          "& .MuiDrawer-paper": {
            width: "85%",
            border: "1px solid #000",
            backgroundColor: "#fff",
            height: "100vh"
          },
        }}
        onClose={() => setDrawerState(false)}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {/* Snackbar */}
        <ErrorSnackbar
          error={errorState.error}
          handleCloseError={() => setErrorState({ error: false, message: "" })}
          errorMsg={errorState.message}
        />
        <Box>
        <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2,
              py: 2,
              borderBottom: "1px solid #000",
            }}
          >
            <Typography
  sx={{
    fontSize: { xs: "16px", sm: "20px", md: "23px", lg: "23px" }, // Responsive font sizes
    fontFamily: "Inter-SemiBold",
    color: colors.textColor,
  }}
>
  Category
</Typography>
            <Stack
              direction="row"
              alignItems={"center"}
              sx={{
                width: "50%",
                gap: 2,
                justifyContent: "flex-end",
              }}
            >
              
              <IconButton onClick={() => setDrawerState(false)}>
            <Close sx={{ fontSize: "32px", color: "#000" }} />
          </IconButton>
            </Stack>
          </Box>
          <Box sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2,
        width: "100%",
        height: "90vh",
        px: 3,
        py: 2,
      }}>
        <Box sx={{ width: "100%", mt: 3, 
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "15px"
         }}> 
        {categoryFilters.map((item, index) => {
                      const currentValue = categoryFilters.find(
                        (option) => option.value === item.value
                      )?.label;
                      return (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            px: 1.5,
                            cursor: "pointer",
                            width: "100%",
                            backgroundColor: "transparent",
                            border: `1px solid ${
                              value === item.value ? colors.primary : "#000000"
                            }`,
                            py: 2,
                          }}
                          onClick={() => setValue(item.value)}
                        >
                          <Typography
                            sx={{
                              color: value === item.value ? colors.primary : "#000000",
                              fontFamily:
                                value === item.value ? "Inter-SemiBold" : "Inter-Regular",
                              fontSize: "16px",
                              width: "100%",
                            }}
                          >
                            {currentValue}
                          </Typography>
                        </Box>
                      );
                    })}
        </Box>
              

                    <Box sx={{ width: "100%", mt: 3 }}>
                                  <SecondaryBtn
                                    text="Reset"
                                    noIcon
                                    width={"100%"}
                                    onClick={() => {
                                      setValue("")
                                    }}
                                  />
                                  <CustomBtn
                                    text="Select & Continue"
                                    Icon={ArrowForward}
                                    width={"100%"}
                                    onClick={()=> {
                                      setDrawerState(false)
                                    }}
                                  />
                                </Box>
          </Box>
        
        </Box>
      </Drawer>
    );
  };
  
  export default CategoryFiltersDrawer;
  